import AIAssistant from './AIAssistant.component';
import AuthenticatedPaths from '/b2b/routing/AuthenticatedRoutes/AuthenticatedRoutes.paths';
import { Box } from '@mui/material';
import { PANEL_MODES } from './state/reducer';
import React from 'react';
import makeStyles from '@mui/styles/makeStyles';
import styles from './AIAssistantPanel.styles';
import { translate } from '/b2b/common/helpers/i18n';
import useAIAssistant from './useAIAssistant';
import { useHistory } from 'react-router-dom';

const useStyles = makeStyles(styles);

/*
 * Global overlay host for the assistant's floating panel modes. Reads panelMode
 * from the provider and, in the side-panel or pop-up modes, renders the assistant
 * as a fixed overlay that leaves the page interactive behind it. Renders nothing
 * while collapsed, or when the assistant is shown fullscreen via its own route.
 * The assistant is only mounted while open so its dialogs and data effects don't
 * run in the background. This is the one panel-mode piece that knows the router,
 * so it owns the switcher's full-screen navigation and hands it down as a callback.
 */
const AIAssistantPanel = () => {
    const classes = useStyles();
    const history = useHistory();
    const { panelMode } = useAIAssistant();

    // Only the floating overlay modes render here; collapsed and fullscreen render
    // nothing. panelMode doubles as the style key (see AIAssistantPanel.styles).
    if (panelMode !== PANEL_MODES.SIDEBAR && panelMode !== PANEL_MODES.WIDGET) {
        return null;
    }

    // Full screen is a real route, not a panel mode; the fullscreen page collapses
    // this overlay on mount. Conversation state lives in the provider, so it carries.
    const handleOpenFullScreen = () => history.push(AuthenticatedPaths.PRIVACY_ADVISOR);

    return (
        <Box
            className={classes[panelMode]}
            role="complementary"
            aria-label={translate('aiAssistant.name')}
        >
            <AIAssistant panelMode={panelMode} onOpenFullScreen={handleOpenFullScreen} />
        </Box>
    );
};

export default AIAssistantPanel;
